<template>
  <div class="previewContainer">
    <el-row type="flex" align="middle" justify="middle" class="preview-empty">
      <el-col v-if="transStatus == 1" :span="24"><uc-empty empty-type="transing" description="正在转码，请稍后查看"></uc-empty></el-col>
      <el-col v-else-if="transStatus == 7||transStatus == 8" :span="24">
        <uc-empty empty-type="transing" description="转码失败，请下载后查看"></uc-empty>
        <el-button size="mini" type="primary" class="downlaod-btn" @click="downlaod">下载</el-button>
      </el-col>
      <el-col v-else-if="transStatus == 2" :span="24">
        <uc-empty empty-type="data" description="此文件类型无法预览，请下载后查看"></uc-empty>
        <el-button size="mini" type="primary" class="downlaod-btn" @click="downlaod">下载</el-button>
      </el-col>
      <el-col v-else-if="transStatus == -1" :span="24">
        <uc-empty empty-type="data" description="此文件已不存在"></uc-empty>
      </el-col>
      <el-col class="pdfDivStyle" v-else :span="24">
        <pdf-preview  v-if="fileType >= 1 && fileType <= 30" :id="parseInt(id)" :preview-url="previewUrl" :pdfName="fileName" @delete="deleteFile"></pdf-preview>
        <video-preview v-if="fileType >= 91 && fileType <= 120" :id="parseInt(id)" :preview-url="previewUrl" @delete="deleteFile" :fileName="fileName" ></video-preview>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {downloadUseForm} from "../../../../common-components/src/utils/fileUtil";
import VideoPreview from "./VideoPreview";
import PdfPreview from "./PdfPreview";

export default {
  data() {
    return {
      id: this.$route.query.fileId,
      previewUrl: '',
      transStatus: 0,
      fileType: 0,
      fileName:''
    }
  },
  components: {
    VideoPreview,
    PdfPreview
  },
  mounted() {
    this.checkPreviewFile();
  },
  methods: {
    checkPreviewFile(){
      let vm = this;
      vm.ucloading.showLoading()
      this.$api.get("/resapi/tw/resource-file/checkPreviewFile", {params: {id: vm.id}}).then(res => {
        vm.ucloading.hideLoading()
        if(!res.success){
          return vm.$message.error(res.info);
        }
        this.transStatus = res.data.transStatus;
        this.fileType = res.data.fileType;
        this.fileName = res.data.fileName||'';
        this.previewUrl = res.data.previewUrl||'';
      }).catch(res => {
        vm.ucloading.hideLoading()
        console.log(res)
      })
    },
    downlaod(){
      let vm = this;
      vm.ucloading.showLoading();
      this.$api.post("/resapi/resource/download/downloadCheck", {ids: vm.id}).then(res => {
        this.ucloading.hideLoading();
        if (!res.success) {
          return vm.$message.error(res.info);
        }
        downloadUseForm(res.data.downloadUrl, {});
      }).catch(error => {
        vm.ucloading.hideLoading();
        console.log(error);
      })
    },
    deleteFile(){
       localStorage.setItem("preview_delete_info",JSON.stringify({"filId":this.id}));
        window.close()
    }
  }
}
</script>

<style scoped lang="scss">
.previewContainer{
  text-align: center;
  height: 100%;

  .preview-empty{
    height: 100%;
  }

  .downlaod-btn{
    margin-top: 50px;
  }
  .pdfDivStyle{
     height: 100%;
  }
}
</style>